import {
  VContainer,
  VRow,
  VCol,
  VTextField,
  VBtn,
  VBtnToggle,
} from "vuetify/lib";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        search: "",
        search_type: "pending",
      }),
    },
  },
  data() {
    this.$set(this.value, "search", "");
    this.$set(this.value, "search_type", "pending");
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.$emit("search");
    },
  },
  render() {
    return (
      <div>
        <VContainer fluid>
          <VRow align="center">
            <VCol>
              <VBtn
                color="primary"
                elevation="2"
                style="margin-left: 20px;"
                onClick={() => {
                  this.$emit("add");
                }}
              >
                创建销售订单
              </VBtn>
              <VBtn
                type="warning"
                elevation="2"
                style="margin-left: 20px;"
                onClick={() => {
                  this.$emit("downloadTemplate");
                }}
              >
                下载导入模板
              </VBtn>
            </VCol>
            <VCol>
              <VBtnToggle
                v-model={this.value.search_type}
                small
                mandatory
                on={{
                  change: () => {
                    this.onSearch();
                  },
                }}
              >
                <VBtn height="32" value="pending">
                  待我处理
                </VBtn>

                <VBtn height="32" value="related">
                  与我相关
                </VBtn>

                <VBtn height="32" value="mine">
                  我发起的
                </VBtn>
              </VBtnToggle>
            </VCol>
            <VCol cols="3">
              <VTextField label="搜索关键词" v-model={this.value.search} />
            </VCol>
            <VCol style="display: flex; align-items: center;">
              <VBtn
                color="primary"
                elevation="2"
                onClick={() => {
                  this.onSearch();
                }}
              >
                搜索
              </VBtn>
            </VCol>
          </VRow>
        </VContainer>
      </div>
    );
  },
};
